var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _vm.approvalLineInfo.aprvalSngleYn == "결재선" && _vm.page != "step1"
        ? [
            _c("table-box", {
              attrs: { "css-type": "type4" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "content",
                    fn: function() {
                      return [
                        _c("dt", [
                          _vm._v(_vm._s(/*단계*/ _vm.$t("PCOP-01-01-01-02")))
                        ]),
                        _c("dd", [
                          _c("span", [
                            _vm._v(_vm._s(/*결재자*/ _vm.$t("MCOM-0000075")))
                          ])
                        ]),
                        _vm._l(_vm.approvalLineInfo.list, function(list, i) {
                          return [
                            _c("dt", { key: "dt" + i }, [
                              _vm._v(_vm._s(i + 1))
                            ]),
                            _c("dd", { key: "dd" + i }, [
                              _c(
                                "span",
                                [
                                  _vm._v(
                                    " " + _vm._s(list.aprvalWWWBnkgLginNM) + " "
                                  ),
                                  list.hoYn == "Y"
                                    ? [
                                        _vm._v(
                                          _vm._s(
                                            /*한국본사*/ _vm.$t("MCOM-0000013")
                                          )
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ])
                          ]
                        })
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1879517365
              )
            }),
            _vm.approvalLineInfo.aprvalMemoAplyYn == "1"
              ? [
                  _c("div", { staticClass: "cont-tit" }, [
                    _c("h6", [
                      _vm._v(_vm._s(/*결재 상신 메모*/ _vm.$t("MCOM-0000014")))
                    ])
                  ]),
                  _c("div", { staticClass: "form-textarea" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.memo,
                          expression: "memo"
                        }
                      ],
                      staticClass: "form-control",
                      domProps: { value: _vm.memo },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.memo = $event.target.value
                        }
                      }
                    })
                  ])
                ]
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }